const subcategories = document.querySelectorAll('.subcategory_button')
const product_list = document.querySelector('product-list')
const subcollection_desc = document.querySelector('.subcollection_desc')
const loader = document.querySelector('.loader')

if (subcategories) {
  subcategories.forEach(sub => {
    sub.addEventListener('click', async () => {
      await reloadSpecificElement(product_list, sub.getAttribute('data-link'), 'product-list')
      deactivateButtons()
      sub.classList.add('is-active')
      subcollection_desc.innerText = sub.getAttribute('data-desc')
    })
  })
}

function deactivateButtons() {
  subcategories.forEach(sub => {
    sub.classList.remove('is-active')
  })
}
function reloadSpecificElement(targetElement, url, elementToExtractSelector) {
    loader.style.display = 'block'
    product_list.classList.add('fadeOut')
    if (targetElement) {
        fetch(url)
            .then(response => response.text())
            .then(data => {
                // Parse the fetched HTML
                const parser = new DOMParser();
                const doc = parser.parseFromString(data, "text/html");

                // Extract the specific element's content
                const extractedElement = doc.querySelector(elementToExtractSelector);
                product_list.classList.remove('fadeOut')
                product_list.classList.remove('fadeIn')
                if (extractedElement) {
                    targetElement.innerHTML = extractedElement.innerHTML;
                } else {
                    console.error(`Element with selector "${elementToExtractSelector}" not found in fetched content`);
                }
              loader.style.display = 'none'
            })
            .catch(error => console.error("Error reloading element:", error));
    } else {
        console.error(`Element with ID "${targetElementId}" not found`);
    }
}